import { DOMAIN } from "shared/SharedConstants";

export const LINKEDIN_PROFILE_URL = "https://www.linkedin.com/company/calmlens";
export const BLUESKY_PROFILE_URL = `https://bsky.app/profile/${DOMAIN}`;
